import { atom } from 'recoil';

export const pushButtonClickState = atom<string | null>({
  key: 'pushButtonClick',
  default: null,
});
